<template>
    <div>
        <table class="table table-hover table-responsive" v-bind:id="id"  width="100%">
          <thead> </thead>
          <tbody> </tbody>
        </table>
    </div>
  </template>
  <script>
    export default {
      name:"TableMaquinas",
      props: {id:'',data_:[],lengthMenu:[]},
      mounted () {
        this.createTable();
        window.admaquinas = this;
      },      
      methods:{
        accionDetalle(dato){
          this.$emit('detalle', dato);
        },
        accionEliminar(dato){
          this.$emit('eliminar', dato);
        },
        createTable(){
          $('#sample_2').DataTable( {
            "data": this.data_,
            deferRender:    true,
            scrollX:        true,
            scrollCollapse: true,
            scroller:       true,
            "lengthMenu": [
              [10, 15, 25,50,100, -1],
              [10, 15, 25,50,100, "All"]
            ],
            order: [
              [8, 'asc'],   //#Estatus 
              [0, 'asc'],   //#RFC
              [1, 'asc'],   //#Cuenta
              [3, 'desc']   //#Año
            ],
            "columns": [
              {"data":"rfc","title":"RFC"},
              {"data":"cuenta","title":"CUENTA"},
              {"data":"nombre_o_razon_social","title":"NOMBRE O RAZON SOCIAL"},
              {"data":"anio","title":"AÑO"},
              {"data":"cantidad_de_maquinas","title":"CANTIDAD DE MAQUINAS","className": "text-center", "targets": "_all"},
              {"data":"carga_inicial_a_200","render": this.checkInfo,"title":"CARGA INICIAL A 200 CUOTAS","className": "text-center", "targets": "_all"},
              {"data":"prorrateo_a_200","render": this.checkInfo,"title":"PRORRATEO A 200 CUOTAS","className": "text-center", "targets": "_all"}, 
              {"data":"prorrateo_a_300","render": this.checkInfo,"title":"PRORRATEO A 300 CUOTAS","className": "text-center", "targets": "_all"}, 
              {"data":"status","render": this.spanEstatus ,"title":"ESTATUS"},
              {"data":"status","render": this.btnDetalle ,"title":"ACCIONES"}
            ]
          });
        },
        btnDetalle( data, type, row, meta){
          let btn="";
          if(data==1){
            btn="<a class='btn btn-icon-only btn-circle blue' data-toggle='modal' href='#portlet-edit' title='Editar Registro'  onclick='accionDetalle("+JSON.stringify(row)+")'><i class='fa fa-pencil'></i></a><a class='btn btn-icon-only btn-circle btn-danger' data-toggle='modal' href='#portlet-del' title='Eliminar Registro' onclick='accionDetalle("+JSON.stringify(row)+")'><i class='fa fa-trash'></i></a>";
          }
          return btn;
        },
        checkInfo( data, type, row, meta){
          let ch="";
          if(data){
            ch="<i class='fa  fa-check-circle-o font-green'></i>"
          }
          return ch;
        },
        spanEstatus( data, type, row, meta){
          let s=data=='1' ? 'btn-success' : 'label-danger';
          let status=data=='1' ? 'ACTIVO' : 'INACTIVO';
          return '<span class="label  btn-circle '+s+'" class="">'+status+' </span>';
        }
      }   
    }
  </script>
<style scoped>
table.dataTable tbody td {
  word-break: break-word; word-break: break-all; white-space: normal;
}
</style>